import { useCallback, useRef } from 'react';
import { requestPlay3 } from '../cdo/cdoPlay3';

// Keep the last successful snapshot during refresh, scoped to this player/session.
// Each revision shares both completed and in-flight reads; older requests cannot
// overwrite a newer revision (or another character's data).
export default function usePlay3PortraitDetails(playerId, sessionId, revision) {
  const cache = useRef(null);
  const previous = cache.current;
  if (!previous || previous.playerId !== playerId || previous.sessionId !== sessionId || previous.revision !== revision) {
    const sameSession = previous?.playerId === playerId && previous?.sessionId === sessionId;
    cache.current = { playerId, sessionId, revision, details: new Map(sameSession
      ? [...previous.details].map(([id, entry]) => [id, { value: entry.value }]) : []) };
  }
  const { details } = cache.current;
  const load = useCallback(beingId => {
    let entry = details.get(beingId);
    if (!entry) { entry = {}; details.set(beingId, entry); }
    if (!entry.pending) {
      entry.pending = Promise.resolve().then(() => requestPlay3(playerId,
        `/relationships?beingId=${encodeURIComponent(beingId)}`)).then(value => {
        entry.value = value;
        return value;
      });
      entry.pending.catch(() => { entry.pending = null; });
    }
    return entry.pending;
  }, [playerId, details]);
  load.peek = beingId => details.get(beingId)?.value;
  return load;
}
